<form [formGroup]='formDetails' novalidate>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: space-between;
        align-items: center;
      ">
        <div class="col">
          <h4>
            Agregar productos
          </h4>
        </div>
        <div class="col d-flex align-items-center" style="max-width: 165px;">
          <p class="m-0"><small>
              <mdb-checkbox formControlName="esProductoLibre">Producto sin SKU</mdb-checkbox>
            </small></p>
        </div>

      </div>

      <div class="filtros-body">
        <div class="row" formGroupName="productoLibre" *ngIf="formDetails.get('esProductoLibre').value">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="codProductLibre" class="form-control" placeholder="000" required
                #codProductLibre formControlName="codigo" monto />
              <label for="codProductLibre">Código de producto</label>
              <div *ngIf="
                    formDetails.get('productoLibre.codigo').invalid &&
                    (formDetails.get('productoLibre.codigo').dirty ||
                    formDetails.get('productoLibre.codigo').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoLibre.codigo').hasError('required')">Ingrese código de
                  producto
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('productoLibre.codigo').hasError('min')">Código de producto debe ser
                  mayor a 0 </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="min-width: 400px;">
            <div class="md-form">
              <input value="" type="text" id="descripcionProductoLibre" class="form-control" placeholder="000" required
                #descripcionProductoLibre formControlName="descripcion" />
              <label for="descripcionProductoLibre">Descripción</label>
              <div *ngIf="
                    formDetails.get('productoLibre.descripcion').invalid &&
                    (formDetails.get('productoLibre.descripcion').dirty ||
                    formDetails.get('productoLibre.descripcion').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoLibre.descripcion').hasError('required')">
                  Ingrese descripción de producto
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="md-form">
              <mdb-select [options]="optionsFormatoProductoLibre" [multiple]="false" [filterEnabled]="true"
                [highlightFirst]="false" placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
              <label>Formato</label>
              <div *ngIf="
                    formDetails.get('productoLibre.formato').invalid &&
                    (formDetails.get('productoLibre.formato').dirty ||
                    formDetails.get('productoLibre.formato').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoLibre.formato').hasError('required')">Ingrese formato
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 150px;">
            <div class="">
              <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
                formControlName="cantidad" monto />
              <label for="cant">Cantidad</label>
              <div *ngIf="
                    formDetails.get('productoLibre.cantidad').invalid &&
                    (formDetails.get('productoLibre.cantidad').dirty ||
                    formDetails.get('productoLibre.cantidad').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoLibre.cantidad').hasError('required')">Ingrese cantidad
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('productoLibre.cantidad').hasError('min')">Cantidad debe ser mayor a 0
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col dato" style="max-width: 150px;">
            <div class="">
              <input value="" type="text" id="precioUnitario" class="form-control" placeholder="000" required
                #precioUnitario formControlName="precioUnitario" monto />
              <label for="precioUnitario">Precio unitario</label>
              <div *ngIf="
                    formDetails.get('productoLibre.precioUnitario').invalid &&
                    (formDetails.get('productoLibre.precioUnitario').dirty ||
                    formDetails.get('productoLibre.precioUnitario').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoLibre.precioUnitario').hasError('required')">
                  Ingrese precio unitario
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('productoLibre.precioUnitario').hasError('min')">
                  Precio unitario debe ser mayor a 0
                </mdb-error>
              </div>
            </div>
          </div>
        </div>
        <div class="row" formGroupName="productoExistente" *ngIf="!formDetails.get('esProductoLibre').value">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="codProduct" class="form-control" placeholder="000" required #codProduct
                formControlName="codigoProducto" />
              <label for="codProduct">Código de producto</label>
              <div *ngIf="
              formDetails.get('productoExistente.codigoProducto').invalid &&
              (formDetails.get('productoExistente.codigoProducto').dirty ||
              formDetails.get('productoExistente.codigoProducto').touched)
            ">
                <mdb-error *ngIf="formDetails.get('productoExistente.codigoProducto').hasError('required')">
                  Ingrese código de producto
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col d-flex">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccionarProducto()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" *ngIf="productoSeleccionado" style="display: contents;">
              {{ productoSeleccionado.descripcion}}
            </h6>
          </div>
          <div class="col">
            <div class="md-form">
              <mdb-select [multiple]="false" [filterEnabled]="true" [options]="optionsFormato" [highlightFirst]="false"
                placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
              <label>Formato</label>
              <div *ngIf="
                    formDetails.get('productoExistente.formato').invalid &&
                    (formDetails.get('productoExistente.formato').dirty ||
                    formDetails.get('productoExistente.formato').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoExistente.formato').hasError('required')">
                  Ingrese formato
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 150px;">
            <div class="">
              <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
                monto formControlName="cantidad" />
              <label for="cant">Cantidad</label>
              <div *ngIf="
                    formDetails.get('productoExistente.cantidad').invalid &&
                    (formDetails.get('productoExistente.cantidad').dirty ||
                    formDetails.get('productoExistente.cantidad').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoExistente.cantidad').hasError('required')">
                  Ingrese cantidad
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('productoExistente.cantidad').hasError('min')">
                  Cantidad debe ser mayor a 0
                </mdb-error>
                <mdb-error
                  *ngIf="formDetails.get('productoExistente.cantidad').value > 1 &&  formDetails.get('productoExistente.formato').value && formDetails.get('productoExistente.formato').value.includes('MED')">
                  La cantidad debe ser 1 o menos cuando el formato contiene 'MED'
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col dato">
            <Strong class="title">Precio unitario</Strong>
            <input formControlName="precioUnitario"
              *ngIf="formDetails.get('productoExistente.precioUnitario').value !== null; else dummyTxt"
              value="{{formDetails.get('productoExistente.precioUnitario').value }}" type="text" id="preciunit"
              class="form-control" required #preciunit monto />
            <span class="value monto"
              *ngIf="formDetails.get('productoExistente.precioUnitario').value === null; else dummyTxt"></span>
            <ng-template #dummyTxt>
              <div class="dummyTxt"></div>
            </ng-template>
            <div *ngIf="
                  formDetails.get('productoExistente.precioUnitario').invalid &&
                  (formDetails.get('productoExistente.precioUnitario').dirty ||
                  formDetails.get('productoExistente.precioUnitario').touched)
                ">
              <mdb-error *ngIf="formDetails.get('productoExistente.precioUnitario').hasError('required')">
                Ingrese precio unitario
              </mdb-error>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col" style="max-width: 200px; display: flex; align-items: center;">
            <h5>Descuentos y recargos</h5>
          </div>
          <div class="col" style="max-width: 200px;" formGroupName="descuento">
            <div class="md-form">
              <input value="" type="text" id="descuentoPorcent" class="form-control" placeholder="%" required
                #descuentoPorcent formControlName="porcentaje" monto />
              <label for="descuentoPorcent">Desc. %</label>
            </div>
          </div>
          <div class="col" style="max-width: 200px;" formGroupName="descuento">
            <div class="md-form">
              <input value="" type="text" id="descuentoPesos" class="form-control" placeholder="$" required
                #descuentoPesos formControlName="monto" monto />
              <label for="descuentoPesos">Desc. $</label>
            </div>
          </div>
          <div class="col" style="max-width: 200px;" formGroupName="recargo">
            <div class="md-form">
              <input value="" type="text" id="recargoPorcent" class="form-control" placeholder="%" required
                #recargoPorcent formControlName="porcentaje" monto />
              <label for="recargoPorcent">Recargo %</label>
            </div>
          </div>
          <div class="col" style="max-width: 200px;" formGroupName="recargo">
            <div class="md-form">
              <input value="" type="text" id="recargoPesos" class="form-control" placeholder="%" required #recargoPesos
                formControlName="monto" monto />
              <label for="recargoPesos">Recargo $</label>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <!-- <button mdbBtn type="submit" size="sm" color="secondary" mdbWavesEffect>
        Agregar producto
      </button> -->
      <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect
        *ngIf="!formDetails.get('esProductoLibre').value" (click)="agregarProducto('NORMAL')"
        [disabled]="!cliente || !productoSeleccionado">
        Agregar producto
      </button>
      <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect
        *ngIf="formDetails.get('esProductoLibre').value" (click)="agregarProducto('LIBRE')" [disabled]="!cliente">
        Agregar producto libre
      </button>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body">
    <div class="row" *ngIf="detalleDocumento.length > 0">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">
                  <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
                </th>
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Formato</th>
                <th scope="col">Precio $</th>
                <th scope="col">Desc. $</th>
                <th scope="col">Recargo $</th>
                <!-- <th scope="col">IVA</th> -->
                <th scope="col">Total $</th>
                <!-- <th></th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detalle of detalleDocumento">
                <td>
                  <mdb-checkbox [checked]="detalle.additionalInfo.checked"
                    (change)='checkDetalle(detalle.additionalInfo)'></mdb-checkbox>
                </td>
                <td>{{ detalle.sku }}</td>
                <td>{{ detalle.descripcion_producto }}</td>
                <td>{{ detalle.cantidad | numerico }}</td>
                <td>{{ detalle.formato_codigo }}</td>
                <td>$ {{ detalle.precio_unitario | numerico }}</td>
                <td>$ {{ detalle.aplicacion_descuento | numerico }}</td>
                <td>$ {{ detalle.aplicacion_recargo | numerico }}</td>
                <!-- <td>---IVA---</td> -->
                <td>$ {{ detalle.monto_total_neto | numerico }}</td>
                <!-- <td>
                  <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect>
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <button type="button" mdbBtn color="warning" mdbWavesEffect size="sm" (click)="eliminarSeleccionados()"
          [disabled]="disableEliminar">
          Eliminar
        </button>

      </div>
    </div>

    <div class="row" *ngIf="detalleDocumento.length > 0 && totales">
      <div class="col">
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="blue lighten-5">
              <tr>
                <th scope="col">SubTotal</th>
                <th scope="col">Descto.</th>
                <th scope="col">Recargo</th>
                <th scope="col">Impto. Adic.</th>
                <th scope="col">Exento</th>
                <th scope="col">Neto</th>
                <th scope="col">IVA</th>
                <th scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody class="blue lighten-5">
              <tr>
                <td>$ {{ totales.subtotal | numerico }}</td>
                <td>$ {{ totales.descuento | numerico }}</td>
                <td>$ {{ totales.recargo | numerico }}</td>
                <td>$ {{ totales.impto_adic | numerico }}</td>
                <td>$ {{ totales.exento | numerico }}</td>
                <td>$ {{ totales.neto | numerico }}</td>
                <td>$ {{ totales.iva | numerico }}</td>
                <td><strong>$ {{ totales.total | numerico }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto (onSelect)="onProductoSeleccionado($event)" [showFiltroActivoInactivo]="false"
  (onNotFound)="onProductoNoEncontrado()" (onRemoteQuery)="getProducts($event)">
</app-modal-seleccionar-producto>

<app-modal-confirm title="Eliminar productos(s)" contentText="¿Desea eliminar productos(s)?">
</app-modal-confirm>